import React, { useEffect,useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";
import { errorToast } from "./common/showtoast";

export default function Epin() {
  const [epins, setEpins] = useState([]);
  const [epinsHistory, setEpinsHistory] = useState([]);
  let history = useHistory();
  useEffect(() => {
    GetEpins(history);
    GetEpinsHistory(history);
  }, [history]);
  const GetEpins = async (history) => {
    let res = await ApiRequest("unusedpins.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        errorToast(res.message);
        history.push("/");
      }
      return;
    }
    console.log(res);
    setEpins(res.items);
  }
  const GetEpinsHistory = async (history) => {
    let res = await ApiRequest("usedpins.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        errorToast(res.message);
        localStorage.clear();
        history.push("/");
      }
      return;
    }
    setEpinsHistory(res.items);
  }
  return (
    <div>
      <PageHeader title="Epin - Bank" />
      <div className="row">
        <div className="col-lg-12 col-md-12 row ml-1 d-flex">
          <div className="card col-lg-6 col-md-6">
            <div className="card-header">
              <h3
                className="card-title text-color-3"
                style={{ fontWeight: 200, fontSize: 22 }}
              >
                                E-Pin Bank
              </h3>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                  style={{ textAlign: "center" }}
                >
                  <thead className="">
                    <tr>
                      <th>S.No</th>
                      <th>Pin ID</th>
                      <th>Pin Pass</th>
                      <th>Product Code</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody >
                    {
                      epins.length <= 0 ? <tr>
                        <td colSpan={"6"}>No records found</td>
                      </tr> : epins.map((e, i) => {
                        return <tr key={i}>
                          <td className="tabletd">{(i + 1)}</td>
                          <td>{e.pinid}</td>
                          <td>{e.pinpass}</td>
                          <td>{e.productcode}</td>
                          <td>{e.pinvalue ? e.pinvalue : "-"}</td>
                          <td>{e.solddate}</td>
                          <td>
                            <Link className="badge badge-primary" to={`/transfer/${e.pinid}/${e.pinpass}`}>Transfer</Link>
                            <Link className="badge badge-primary" to={`/register/${localStorage.getItem("username")}/${e.pinid}/${e.pinpass}`}>Register</Link>
                          </td>
                        </tr>
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="card col-lg-6 col-md-6">
            <div className="card-header">
              <h3
                className="card-title text-color-3"
                style={{ fontWeight: 200, fontSize: 22 }}
              >
                                E-Pin - Used
              </h3>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                  style={{ textAlign: "center" }}
                >
                  <thead className="">
                    <tr>
                      <th>S.No</th>
                      <th>Used For</th>
                      <th>Pin ID</th>
                      <th>Pin Pass</th>
                      <th>Product Code</th>
                      <th>Amount</th>
                      <th>Purchased Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      epinsHistory.length <= 0 ? <tr>
                        <td colSpan={"7"}>No records found</td>
                      </tr> : epinsHistory.map((e, i) => {
                        return <tr key={i}>
                          <td className="tabletd">{(i + 1)}</td>
                          <td>{e.usedby}</td>
                          <td>{e.pinid}</td>
                          <td>{e.pinpass}</td>
                          <td>{e.productcode}</td>
                          <td>{e.pinvalue ? e.pinvalue : "-"}</td>
                          <td>{e.solddate}</td>
                        </tr>
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}